import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserService } from "../../services/user.service";
import { PasswordResetRequest } from "../../models/user.model";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  passwordResetRequest: PasswordResetRequest = new PasswordResetRequest();
  passwordResetSuccess: boolean = false;
  passwordResetFail: boolean = false;
  passwordCheck: string;
  onDestroy$ = new Subject();

  constructor(
    private userService: UserService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.passwordResetRequest.token =
      this.route.snapshot.queryParamMap.get("token");
    this.passwordResetRequest.email =
      this.route.snapshot.queryParamMap.get("email");
  }

  /***
   *  Reset password
   */
  resetPassword() {
    // Reset success/fail flags
    this.passwordResetSuccess = false;
    this.passwordResetFail = false;
    this.userService
      .resetPasswordUserAccount(this.passwordResetRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.passwordResetSuccess = true;
          this.passwordResetFail = false;
        },
        (error) => {
          this.passwordResetSuccess = false;
          this.passwordResetFail = true;
        }
      );
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
